import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => ({
    searchProviderRequestUrl: state.search.searchProviderRequestUrl,
})

export default connect(mapStateToProps)
